import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile
} from "@/helper/requests"

const state = {
  science: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getScience: state => state.science.items,
  getScienceCount: state => state.science.count,
  getScienceCurrentUrl: state => state.science.currentUrl,
  getScienceNext: state => state.science.next,
  getSciencePrev: state => state.science.prev,
  getScienceDetail: state => state.science.detail,
  isLoadingScience: state => state.science.loading,
  saveScienceError: state => state.science.error,
}

const actions = {
  loadScience: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MEMBER.SCIENCE.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingScience) {
      commit('SET_SCIENCE_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_SCIENCE', data.results)
          commit('SET_SCIENCE_COUNT', data.count)
          commit('SET_SCIENCE_CURRENT_URL', url)
          commit('SET_SCIENCE_NEXT_URL', data.next)
          commit('SET_SCIENCE_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_SCIENCE_LOADING_END')
          commit('SAVE_SCIENCE_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createScience: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SCIENCE.CREATE()
    commit('SET_SCIENCE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  simplifiedCreateScience: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SIMPLIFIED.SCIENCE()
    commit('SET_SCIENCE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updateScience: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SCIENCE.UPDATE()
    commit('SET_SCIENCE_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_SCIENCE_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadScienceDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.SCIENCE.SCIENCE.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_SCIENCE_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_SCIENCE_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_SCIENCE: (state, value) => {
    state.science.items = value
  },
  SET_SCIENCE_DETAIL: (state, value) => {
    state.science.detail = value
  },
  SET_SCIENCE_COUNT: (state, value) => {
    state.science.count = value
  },
  SET_SCIENCE_CURRENT_URL: (state, value) => {
    state.science.currentUrl = value
  },
  SET_SCIENCE_NEXT_URL: (state, value) => {
    state.science.next = value
  },
  SET_SCIENCE_PREV_URL: (state, value) => {
    state.science.prev = value
  },
  SET_SCIENCE_LOADING: (state) => {
    state.science.loading = true
  },
  SET_SCIENCE_LOADING_END: (state) => {
    state.science.loading = false
  },
  SAVE_SCIENCE_ERROR: (state, error) => {
    state.science.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
